import { URL } from "../store";

// Anything that is not a usable path (null, [], "undefined", "null", ...) must fall back to a placeholder
// instead of becoming a request to the API root, which the browser blocks and logs as an error.
function isUsablePath(picture) {
    return typeof picture === "string" && picture.trim() !== "" && !/undefined|null/.test(picture);
}

export function pictureSource(picture, user) {
    if (isUsablePath(picture)) return URL + picture;

    return user && user.sex === "female" ? "/img/woman.png" : "/img/man.png";
}

export default pictureSource;
